import {
  chatLastMessageUpdate,
  clearChatRoomTotalUndelivered,
  deleteMessage,
  deleteRoomFromList,
  restoreChatRoom,
  searchChatMessage,
  setDeleteMessageError,
  setDialogs,
  setEditMessageError,
  setGlobalUndelivered,
  setMessages,
  setNewMessage,
  setNextPageMessages,
  updateMessage,
} from '../redux/actions/chat.action'
import {
  newSupportMessageAction,
  resetTotalUndelivered,
  setNextPageSupportMessages,
  setSupportStatus,
  setSupportUndelivered,
  updateSupportMessages,
  deleteSupportMessage,
  updateSupportMessage,
  setSupportDeleteMessageError,
  setSupportEditMessageError,
  searchSupportMessage,
  setAnonymousId,
} from '../redux/support/support.action'
import { notify } from '../helpers/notify'

import { addNotifications, setCounterNotifications } from '../redux/actions/notifications.action'
import { events } from '../constants/constans.js'
import {
  setBillingEvent,
  setBillingPermissionCurrent,
  setShouldClosePaymentForm,
} from '../redux/billing/billing.action'
import { setSurveyStatusAction, setSurveyDataAction } from '../redux/ui/ui.action'
import { isExpired } from '../api/getApi.js'
import { getRefreshToken } from '../api/getApi.js'
import { setToken } from '../redux/actions/user.action.js'
import Cookies from 'js-cookie'
import Socket from './index.js'
import { urlProvider } from './index.js'

export const socketEvent = (event, payload, chat_id) => (dispatch, getState) => {
  console.log('%c%s', 'color: #43927C;', event, payload)

  let isRefreshing = false
  switch (event) {
    case 'chat.rooms':
      dispatch(setDialogs(payload))
      console.log('payload', payload)
      break

    case 'chat.messages':
      // if payload has last_message_id, call setNextPageMessages
      if (payload.last_message_id) {
        dispatch(setNextPageMessages(payload))
      } else {
        dispatch(setMessages(payload))
      }

      break

    case 'new.chat.message':
      dispatch(setNewMessage(payload, chat_id))
      break

    case 'chat.message.deleted':
      dispatch(deleteMessage(payload.chat_id, payload.id, payload.total_undelivered))
      break

    case 'chat.message.updated':
      dispatch(updateMessage(payload))
      break

    case 'chat.last.message.update': {
      const { id, message, chat_id } = payload

      // if the user deleted the last message, delete the chat room with him
      if (!id && !message) {
        dispatch(deleteRoomFromList(chat_id))
      }

      dispatch(chatLastMessageUpdate(payload))
      break
    }

    case 'chat.total.undelivered':
      dispatch(setGlobalUndelivered(payload))
      dispatch(setSupportUndelivered(payload))
      break

    case 'new.chat.room':
      dispatch(restoreChatRoom(payload))
      dispatch(setGlobalUndelivered(payload))
      break

    case 'chat.room.auto.restore':
      dispatch(restoreChatRoom(payload))
      dispatch(setGlobalUndelivered(payload))
      break

    case 'error.chat.edit.message':
      dispatch(setEditMessageError(payload.message))
      break

    case 'error.chat.delete.message':
      dispatch(setDeleteMessageError(payload.message))
      break

    case 'error.send.message':
      notify.error('Error', payload.message)
      break

    case 'search.chat.message':
      dispatch(searchChatMessage(payload))
      break

    //  SUPPORT

    case 'support.messages':
      if (payload.last_message_id) {
        dispatch(setNextPageSupportMessages(payload))
      } else {
        dispatch(updateSupportMessages(payload))
      }

      break

    case 'support.new.chat.message':
      dispatch(newSupportMessageAction(payload))
      break

    case 'error.message':
      notify.error('Error', payload.message)
      break

    case 'error':
      if (payload.message === 'Authorization for seafarer failed') {
        const token = JSON.parse(localStorage.getItem('user'))

        if (!token || !token.refresh_token || isRefreshing) {
          break // ничего не делаем, либо токенов нет, либо уже идёт рефреш
        }

        if (isExpired(token.expires_date)) {
          isRefreshing = true

          getRefreshToken(token.refresh_token)
            .then((newTokens) => {
              if (newTokens.ok && newTokens.access_token) {
                // Расчёт нового expires_date
                const expiresIn = newTokens.expires_in || 3600 // если сервер не вернул expires_in, используем 1 час по умолчанию
                const expiresDate = Date.now() + expiresIn * 1000

                const updatedTokens = {
                  ...newTokens,
                  expires_date: expiresDate,
                }

                // обновляем токены
                dispatch(setToken(updatedTokens))
                Cookies.set('token', updatedTokens.access_token, { path: '/' })
                localStorage.setItem('user', JSON.stringify(updatedTokens))

                // обновляем URL сокета с новым токеном
                const newUrl = urlProvider()
                Socket.url = newUrl

                // отключаем и переподключаем сокет
                Socket.close()
                setTimeout(() => {
                  Socket.reconnect()
                }, 300)
              } else {
                console.warn('Не удалось обновить токен (не ok)')
              }
            })
            .catch((error) => {
              // console.error('❌ Ошибка обновления токена:', error)
            })
            .finally(() => {
              isRefreshing = false
            })
        } else {
          console.warn('⚠️ Токен ещё не истёк, но авторизация не прошла.')
        }
      }
      break

    case 'no.chat.messages':
      window.location.href = '/profile/chat'
      break

    case 'chat.message.was.delivered':
      dispatch(clearChatRoomTotalUndelivered(payload))
      break

    case 'support.chat.message.was.delivered':
      dispatch(resetTotalUndelivered(payload))
      break

    case 'support.chat.status':
      dispatch(setSupportStatus(payload))
      break

    case 'support.chat.message.deleted':
      dispatch(deleteSupportMessage(payload.id))
      break

    case 'support.chat.message.updated':
      dispatch(updateSupportMessage(payload))
      break

    case 'error.support.chat.edit.message':
      dispatch(setSupportEditMessageError(payload.message))
      break

    case 'error.support.chat.delete.message':
      dispatch(setSupportDeleteMessageError(payload.message))
      break

    case 'search.support.message':
      dispatch(searchSupportMessage(payload))
      break

    case 'anonymous.uuid':
      dispatch(setAnonymousId(payload.uuid))
      break

    //events&alerts

    case 'events.event.new':
      window.location === '/profile/notification/list' && dispatch(addNotifications(payload))
      break

    case 'events.counter.total':
      dispatch(setCounterNotifications(payload.events))
      break

    //billing
    case events.billing.permissionsCurrent:
      dispatch(setBillingPermissionCurrent(payload))
      break
    case events.billing.cardDetach:
      notify.info('Info', 'Your card has been detached!')
      break
    case events.billing.subscriptionUnPaid:
      notify.info('Info', 'The payment was not successful!')
      dispatch(setBillingEvent(false))
      break
    case events.billing.subscriptionPaid:
      notify.info('Info', 'Your payment has been successfully processed!')
      dispatch(setBillingEvent(false))
      dispatch(setShouldClosePaymentForm(true))
      break
    case events.billing.subscriptionCanceled:
      notify.info('Info', 'Your subscription has been canceled!')
      break

    case events.billing.paymentRequiresConfirmation:
      notify.info('Info', 'You have requires confirmation payment, please go to the billing page!')
      dispatch(setBillingEvent(true))

      break

    // seafarer survey

    case 'connection.status':
      const currentState = getState()
      const surveyData = currentState?.ui?.surveyData

      if (surveyData && Array.isArray(surveyData) && surveyData.length > 0) {
        dispatch(setSurveyStatusAction(true))

        if (Socket.isReady) {
          Socket.emit('company_survey.get_survey', {
            vacancy_id: surveyData[0],
          })
        }
      }
      break

    case events.seafarer_survey.list:
      const urlParams = new URLSearchParams(window.location.search)
      const surveyParam = urlParams.get('survey')
      if (surveyParam === 'true') {
        if (payload.has_survey === true) {
          dispatch(setSurveyStatusAction(true))

          if (Socket.isReady) {
            Socket.emit('seafarer_survey.get_survey', {})
          }
        } else if (payload.has_survey === false) {
          dispatch(setSurveyStatusAction(true))
          dispatch(setSurveyDataAction({ no_surveys_found: true }))
        }
      } else {
        dispatch(setSurveyStatusAction(payload.has_survey))
      }
      break

    case 'seafarer_survey.get_survey':
    case events.seafarer_survey.getSurvey:
      const urlParamsGetSurvey = new URLSearchParams(window.location.search)
      const surveyParamGetSurvey = urlParamsGetSurvey.get('survey')

      if (surveyParamGetSurvey === 'true') {
        if (payload && payload.vacancy_offers && payload.vacancy_offers.length > 0) {
          dispatch(setSurveyDataAction(payload))
        } else {
          return
        }
      } else {
        if (payload && payload.vacancy_offers && payload.vacancy_offers.length > 0) {
          dispatch(setSurveyStatusAction(true))
        }
        dispatch(setSurveyDataAction(payload))
      }
      break

    case events.seafarer_survey.closed:
      if (document.visibilityState !== 'visible') {
        dispatch(setSurveyStatusAction(false))
      }
      break

    case 'seafarer_survey.opened':
    case events.seafarer_survey.opened:
      dispatch(setSurveyStatusAction(payload.has_survey))
      if (Socket.isReady) {
        Socket.emit('seafarer_survey.get_survey', {})
      }
      break

    // work statistics

    default:
      return
  }
}
